<ul class="list-group mb-3">
  @if (dragAndDropEnabledForBaseMenuItems) {
    <div [(dragulaModel)]="baseMenuItems"
      dragula="{{dragAndDropBaseMenuItems}}">
      @for (pageItem of baseMenuItems; track pageItem) {
        <scitis-page-item (deletePageItem)="onDeletePageItem(pageItem)" (editPageItem)="onEditPageItem(pageItem)"
          (propertiesFallback)="setPropertiesFallback($event)"
          (disableSaveButton)="onDisableSaveButton($event)" (pageFormIsActive)="onDeactivateForms($event)"
          (unsharePageItem)="onUnsharePageItem(pageItem)"
          [baseMenuItems]="baseMenuItems" [isAdminOrHigher]="isAdminOrHigher" [isHigherThanAdmin]="isHigherThanAdmin"
          [isBaseMenuItem]="true"
          [pageItem]="pageItem" [pageTypeOptions]="pageTypeOptions"
          [userMenuItems]="userMenuItems"
          [allPagesInsideNode]="allPagesInsideNode"
          [pageItemsToBeDeleted]="pageItemsToBeDeleted"
          [menuItemType]="menuItemType"
          class="list-group-item edit-menu-item">
        </scitis-page-item>
      }
    </div>
  }

  @if (!dragAndDropEnabledForBaseMenuItems) {
    <div>
      @for (pageItem of baseMenuItems; track pageItem) {
        <scitis-page-item (deletePageItem)="onDeletePageItem(pageItem)" (propertiesFallback)="setPropertiesFallback($event)" (editPageItem)="onEditPageItem(pageItem)"
          (disableSaveButton)="onDisableSaveButton($event)" (pageFormIsActive)="onDeactivateForms($event)"
          (unsharePageItem)="onUnsharePageItem(pageItem)"
          [isAdminOrHigher]="isAdminOrHigher" [isHigherThanAdmin]="isHigherThanAdmin" [isBaseMenuItem]="true"
          [pageItem]="pageItem" [pageTypeOptions]="pageTypeOptions"
          [userMenuItems]="userMenuItems"
          [allPagesInsideNode]="allPagesInsideNode"
          [pageItemsToBeDeleted]="pageItemsToBeDeleted"
          [menuItemType]="menuItemType"
          class="list-group-item edit-menu-item-disabled">
        </scitis-page-item>
      }
    </div>
  }
</ul>

@if (showUserMenuItems) {
  <div>
    <h3 class="h6 section-fixed" translate>User Menu Items</h3>
    @if (userMenuItems.length > 0) {
      <ul class="list-group mb-3">
        @if (userMenuItems.length > 0) {
          <div [(dragulaModel)]="userMenuItems" [dragula]="dragAndDropUserMenuItems">
            @for (pageItem of userMenuItems; track pageItem) {
              <scitis-page-item (deletePageItem)="onDeletePageItem($event)" (editNodeItem)="onEditNodeItem($event)"
                (propertiesFallback)="setPropertiesFallback($event)"
                (editPageItem)="onEditPageItem(pageItem)" (sharePageItem)="onSharePageItem($event)"
                (sharePageItemInsideNode)="onSharePageItemInsideNode($event)"
                (updatedItemsInsideNode)="onItemsInsideNodeChanged($event)"
                (editPageItemInsideNode)="onEditPageItemInsideNode($event)"
                (updatedItemsInsideNodeAfterDelete)="onUpdateUserMenuItemsAfterNodeDelete($event)"
                (disableSaveButton)="onDisableSaveButton($event)"
                (pageFormIsActive)="onDeactivateForms($event)"
                (itemsInsideNode)="onGetItemsInsideNode($event)"
                [dragAndDropUserMenuItemsInProgress]="dragAndDropUserMenuItemsInProgress"
                [isAdminOrHigher]="isAdminOrHigher" [isHigherThanAdmin]="isHigherThanAdmin"
                [isBaseMenuItem]="isBaseMenuItem(pageItem)" [pageItem]="pageItem"
                [pageTypeOptions]="pageTypeOptions"
                [baseMenuItems]="baseMenuItems"
                [userMenuItems]="userMenuItems"
                [refreshNodes]="refreshNodes"
                [allPagesInsideNode]="allPagesInsideNode"
                [pageItemsToBeDeleted]="pageItemsToBeDeleted"
                class="list-group-item edit-menu-item" [ngClass]="nodeClass(pageItem)"   [menuItemType]="menuItemType">
              </scitis-page-item>
            }
          </div>
        }
      </ul>
    }
    @if (userMenuItems.length <= 0) {
      <div class="alert alert-secondary mb-3">
        <span>{{ 'This navigation element currently contains no user pages.' | translate }}</span>
      </div>
    }
  </div>
}
